type TagChipProps = {
  children: string;
  variant?: "default" | "primary" | "accent";
};

export default function TagChip({ children, variant = "default" }: TagChipProps) {
  const styles: Record<string, string> = {
    default: "bg-secondary-100 text-secondary-900 border-secondary-200",
    primary: "bg-primary-100 text-primary-800 border-primary-200",
    accent: "bg-accent-100 text-accent-800 border-accent-200",
  };

  return (
    <span
      className={`px-2.5 py-1 text-xs rounded-full border whitespace-nowrap ${styles[variant]}`}
    >
      {children}
    </span>
  );
}